module.exports = __webpack_public_path__ + "static/media/LH_Carousel.5cb33362.jpg";